import { render, staticRenderFns } from "./CartaoInformacoesDadosCadastrais.vue?vue&type=template&id=128d3a6a&scoped=true"
import script from "./CartaoInformacoesDadosCadastrais.vue?vue&type=script&lang=js"
export * from "./CartaoInformacoesDadosCadastrais.vue?vue&type=script&lang=js"
import style0 from "./CartaoInformacoesDadosCadastrais.vue?vue&type=style&index=0&id=128d3a6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128d3a6a",
  null
  
)

export default component.exports